import styled from 'styled-components';

export const AskEchoButton = styled.button`
  width: 10rem;
  height: 3.1rem;
  padding: 0.2rem 1.2rem 0.3rem 1.2rem;
  border-radius: 3.6rem;
  background: rgba(45, 61, 95, 1);
  color: white;
  box-shadow: 0rem 0.3rem 1.3rem 0rem rgba(21, 28, 43, 0.6);
  z-index: 20;
  position: absolute;
  left: 0;
  margin: 0;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  &:hover {
    color: rgba(163, 234, 42, 1);
  }
`;
